import './general/contants';
import './general/pubsub';
import './general/global';

import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { Navigation, Pagination, Scrollbar, Thumbs, Mousewheel, A11y, Autoplay, FreeMode } from 'swiper/modules';

Swiper.use([Navigation, Pagination, Scrollbar, Thumbs, Mousewheel, A11y, Autoplay, FreeMode]);
window.Swiper = Swiper;

import registerComponents from './components';

registerComponents();

import registerControllers from './controllers';

registerControllers();

import './general/ajaxinate';
import './general/animations';

import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';
window.GLightbox = GLightbox;
